import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReligionService {

  constructor(private  httpClient: HttpClient) {
  }

  getReligions() {
    return this.httpClient.get('/systemconfig/religion/');
  }

  /////////////////old///////////////////
  getReligion(id) {
    return this.httpClient.get(`/systemconfig/religion/${id}/`);
  }

  getsReligion(id){
    return this.httpClient.get('/systemconfig/religions/',{params : {id:id}})
  }

  postReligion(religion) {
    return this.httpClient.post('/systemconfig/religion/', religion);
  }

  //////////////////old///////////////
  updateReligion(id, religion) {
    return this.httpClient.patch(`/systemconfig/religion/${id}/`, religion);
  }

  updateReligions(religion){
    return this.httpClient.post('/systemconfig/religions/',religion)
  }
}
